import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class PublicProductAuthorizeResponse {
  @jsonMember(String)
  public readonly accessToken!: string;
}
